<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { mapState } from "vuex";
import { getCachedPages, loadPages } from "@/state/helpers/pages.helper";

export default {
  locales: {
    pt: {
      "Go to store": "Ir para a loja virtual",
      Menu: "Menu",
      Dashboard: "Painel",
      Register: "Cadastrar",
      Courses: "Cursos",
      Store: "Loja",
      Products: "Produtos",
      Cart: "Carrinho",
      "My Orders": "Meus Pedidos",
      Wallet: "Carteira",
      Deposit: "Depositar",
      Extract: "Extrato",
      Network: "Rede",
      Profit: "Rendimento",
      Activation: "Ativação",
      Balance: "Saldo",
      Voucher: "Voucher",
      Transfer: "Transferir",
      Pay: "Pagar",
      Withdrawal: "Sacar",
      "Withdrawal History": "Histórico de Saque",
      Sponsored: "Indicados",
      Team: "Equipe",
      Reports: "Relatórios",
      "Bonus Referral": "Bônus Indicação",
      "Bonus Team": "Bônus Equipe",
      "Bonus Shopping": "Bônus Compras",
      Graduation: "Graduação",
      Support: "Suporte",
      Downloads: "Downloads",
      FAQ: "FAQ",
      "Contact Us": "Fale Conosco",
      Points: "Pontos",
      "My Points": "Meus Pontos",
      "Monthly Activation": "Ativação Mensal",
      Referred: "Indicados",
      "My Clients": "Meus Clientes",
      "Refer Client": "Indicar Cliente",
      Brokers: "Corretores",
      "Refer Broker": "Indicar Corretor",
      "How it works": "Como Funciona",
      Help: "Ajuda",
      Experiences: "Experiências",
      "Redemption History": "Histórico de resgates",
    },
    es: {
      "Go to store": "Ir a la tienda virtual",
      Menu: "Menu",
      Dashboard: "Panel",
      Register: "Registro",
      Courses: "Cursos",
      Store: "Tienda",
      Products: "Productos",
      Cart: "Cesta",
      "My Orders": "Mis Pedidos",
      Wallet: "Cartera",
      Deposit: "Depositar",
      Extract: "Extracto",
      Network: "Red",
      Profit: "Rendimiento",
      Activation: "Activación",
      Balance: "Saldo",
      Voucher: "Cupón",
      Transfer: "Transferir",
      Pay: "Pagar",
      Withdrawal: "Retirada",
      "Withdrawal History": "Historia de Retirada",
      Sponsored: "Patrocinados",
      Team: "Equipo",
      Reports: "Informes",
      "Bonus Referral": "Bonus Patrocinio",
      "Bonus Team": "Bônus Equipo",
      "Bonus Shopping": "Bônus Compras",
      Graduation: "Graduación",
      Support: "Soporte",
      Downloads: "Descargas",
      FAQ: "FAQ",
      "Contact Us": "Contáctenos",
      Points: "Puntos",
      "My Points": "Mis Puntos",
      "Monthly Activation": "Activación Mensual",
      Referred: "Referidos",
      "My Clients": "Mis Clientes",
      "Refer Client": "Indicar Cliente",
      Brokers: "Corredores",
      "Refer Broker": "Indicar Corredor",
      "How it works": "Cómo Funciona",
      Help: "Ayuda",
      Experiences: "Experiencias",
      "Redemption History": "Historial de canjes",
    },
  },
  data() {
    return {
      // Páginas ativas de "Como Funciona", cadastradas no admin (GET pages)
      // Começa com a lista salva no localStorage (sem esperar a API)
      pages: getCachedPages(),
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  watch: {
    // Atualiza o item ativo na navegação interna
    $route() {
      this.$nextTick(() => {
        this.activateMenuItem();
      });
    },
  },
  mounted: function () {
    document.body.setAttribute("data-sidebar", "light");
    new MetisMenu("#side-menu");
    this.activateMenuItem();
    this.getPages();
  },
  methods: {
    // Carrega o submenu "Como Funciona" a partir das páginas ativas do banco
    // Consulta a API uma vez por entrada no app e salva no localStorage
    getPages() {
      loadPages().then((list) => {
        this.pages = list;
        this.$nextTick(() => {
          this.activateMenuItem();
        });
      });
    },
    // Marca o item do menu correspondente à rota atual
    activateMenuItem() {
      const menu = document.getElementById("side-menu");
      if (!menu) return;

      // Limpa as marcações da rota anterior
      // (apenas o link e o <li> do link; os grupos abertos continuam controlados pelo MetisMenu)
      menu.querySelectorAll(".side-nav-link-ref.active").forEach((el) => {
        el.classList.remove("active");
        if (el.parentElement) el.parentElement.classList.remove("mm-active");
      });

      const links = menu.getElementsByClassName("side-nav-link-ref");
      let matchingMenuItem = null;
      for (let i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
          break;
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        const parent = matchingMenuItem.parentElement;

        if (parent) {
          parent.classList.add("mm-active");
          // Abre todos os grupos ancestrais (inclui subgrupos, ex.: Meus Pontos > Carteira)
          let parent2 = parent.parentElement.closest("ul");
          while (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (!parent3) break;
            parent3.classList.add("mm-active");
            const childAnchor = parent3.querySelector(".has-arrow");
            const childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            parent2 = parent3.parentElement ? parent3.parentElement.closest("ul") : null;
          }
        }
      }
    },
  },
};
</script>

<template>
  <div id="sidebar-menu" class="pt-3">
    <ul id="side-menu" class="metismenu list-unstyled">
      <li>
        <router-link tag="a" to="/" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
          <span class="notranslate">{{ t("Dashboard") }}</span>
        </router-link>
      </li>
      <li v-show="pages.length > 0">
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758c.526 0 1.042.214 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.079.182.149.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.047.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.015 2.015 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.758 18H4V5h6c.552 0 1 .449 1 1v12.689A4.032 4.032 0 0 0 8.758 18zM20 18h-4.758c-.799 0-1.584.246-2.242.689V6c0-.551.448-1 1-1h6v13z"></path></svg>
          <span class="notranslate">{{ t("How it works") }}</span>
        </a>
        <ul class="sub-menu">
          <!-- Itens dinâmicos: páginas ativas cadastradas no admin, na ordem definida lá -->
          <li v-for="page in pages" :key="page.slug">
            <router-link tag="a" :to="'/comofunciona/' + page.slug" class="side-nav-link-ref" active-class="active">
              <span class="notranslate">{{ page.title }}</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"></path></svg>
          <span class="notranslate">{{ t("Referred") }}</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/clients" class="side-nav-link-ref">
              <span class="notranslate">{{ t("My Clients") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/clients/create" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Refer Client") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/network/sponsored" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Brokers") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/network/invite" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Refer Broker") }}</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link tag="a" to="/experiences" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M20 7h-1.209A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-4.5-3c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.478c.511-1.576 1.253-3 1.978-3zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM4 9h7v2H4V9zm2 11v-7h5v7H6zm12 0h-5v-7h5v7zm-5-9V9.085L13.017 9H20l.001 2H13z"></path></svg>
          <span class="notranslate">{{ t("Experiences") }}</span>
        </router-link>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M16 12h2v4h-2z"></path>
            <path d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z"></path>
          </svg>
          <span class="notranslate">{{ t("My Points") }}</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/points" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Balance") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/points/extract" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Extract") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/experiences/vouchers" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Redemption History") }}</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 8z"></path></svg>
          <span class="notranslate">{{ t("Wallet") }}</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/wallet/extract" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Extract") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/wallet/withdrawal" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Withdrawal") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/wallet/withdrawal/history" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Withdrawal History") }}</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"></path>
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
          </svg>
          <span class="notranslate">{{ t("Help") }}</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/faq" class="side-nav-link-ref">
              <span class="notranslate">{{ t("FAQ") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/downloads" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Downloads") }}</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/contact" class="side-nav-link-ref">
              <span class="notranslate">{{ t("Contact Us") }}</span>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.py-2 {
  padding: 0.9rem 1.5rem 0.7rem !important;
}
.py-2 i,
.py-2 span {
  line-height: 0px !important;
  padding-bottom: 0 !important;
}
.py-2 i {
  margin-top: -4px;
}
</style>